import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-s bg-white block first-of-type:rounded-t last-of-type:rounded-b cursor-pointer" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "not-first-of-type:ml-s flex-1" }

import CoreIcon from "./CoreIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ListTile',
  props: {
    showTrailing: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "leading"),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "main", { class: "text-base font-medium text-gray-800" })
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "trailing", { class: "text-base font-medium text-gray-800" }, () => [
          (_ctx.showTrailing !== false)
            ? (_openBlock(), _createBlock(CoreIcon, {
                key: 0,
                icon: "more",
                class: "opacity-30"
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})